import React, {Fragment} from 'react'
import { graphql, StaticQuery, navigate, Link } from 'gatsby'
import {Elements, StripeProvider} from 'react-stripe-elements';
import PaymentForm from './PaymentForm';
import Spinner from '../Spinner'
import Fab from '@material-ui/core/Fab';
import moment from 'moment'
import { connect } from "react-redux"
import {checkEmail, checkEmailPremium, validateEmailDomain, emailDomainFormat} from '../../utils/Helper'
import {fieldErrors} from '../../utils/errors'
import Lock from '../../assets/lock.svg'
import GrayArrow from '../../assets/gray_arrow.svg'
import { logEvent, pushToDataLayer } from '../Analytics'

class Quiz extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            step : 0,
            contentNo: 0,
            contentType: '',
            loading: false,
            email: '',
            termCondition: false,
            emailDomainError: ''
        }
    }

    handleInput = (e) => {
        this.setState({email: e.target.value, emailDomainError: ''})
        
		if(validateEmailDomain(e.target.value)){
            this.setState({email: e.target.value, emailDomainError: fieldErrors.emailDomain})
		}
    }

    handleClick = (e) => {
        this.setState({termCondition: e.target.checked})
    }

    gotoStep = (step, page, type) => {
        this.setState({step: step, contentNo: page})

        if(typeof type !== 'undefined'){
            this.setState({contentType: type})
        }
    }

    domainCorrection = () => {
        const {email} = this.state;
		var correctEmail = emailDomainFormat(email);
        this.setState({email: correctEmail})
	}

    back = (step) => {
        this.setState({step: step})
    }

    validate = () => {
        const { email, termCondition } = this.state;
        const { dispatchCheckboxError, dispatchEmailError, dispatchStripeError, dispatchGenerateToken, dispatchDisabledButton, dispatchSubmitFrom } = this.props;
        
        dispatchCheckboxError('') 
        dispatchEmailError('')

        if (email.length === 0) return dispatchEmailError(fieldErrors.emailEmpty)
        if (!checkEmail(email)) return dispatchEmailError(fieldErrors.invalidEmail)
        if (!termCondition) return dispatchCheckboxError(fieldErrors.terms)
        
        dispatchStripeError('');
        dispatchDisabledButton(true)
        dispatchSubmitFrom(true)

        checkEmailPremium(email, (resp) => {
            if(!resp){
                dispatchDisabledButton(true)
                dispatchSubmitFrom(true)
                dispatchGenerateToken(true);
			}else{
				dispatchEmailError(fieldErrors.userAlreadyPremium);
                dispatchDisabledButton(false)
                dispatchSubmitFrom(false)
            }
        })
    }

    registerSeniorUser = () => {
        pushToDataLayer('addtocart_edimia', 'Cart', 'AddToCart', 'Edimia');
        
        const { token, dispatchStripeError, dispatchDisabledButton, dispatchSubmitFrom, dispatchSetToken } = this.props;
        const { email } = this.state;

        
            const formState = {
                token: token,
                plan: 'junior',
                email: email,
                location: "SE",
                campaign: 'common',
                trail: 30,
                coupon: 'true',
                origin: typeof window !== 'undefined' ? window.location.href : ''
            }

            dispatchSetToken('')

            fetch(`${process.env.API_URI}/users/create`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formState)
            })
            .then(resp => resp.json())
            .then(resp => {
                console.log('resp', resp)
                if (resp.status === 200) {
                    pushToDataLayer('addtocart_edimia', 'Purchase', 'done', 'Edimia');
                    navigate(
                        '/congrats',
                        { state: {email, plan: 'junior', userId: resp.userId, campaign: 'common'} }
                    )
                } else {
                    dispatchStripeError(resp.errorMsg)
                    dispatchDisabledButton(false)
                    dispatchSubmitFrom(false)
                }
            })
            .catch(error => console.error(error))
        
    }

    render(){
        const { step, contentNo, contentType, email, emailDomainError } = this.state;
        const { token, buttonDisabled, submitForm, stripeError, juniorEmailError, juniorCheckboxError,
            dispatchDisabledButton, dispatchSubmitFrom} = this.props;

        if(token !== ''){
            this.registerSeniorUser()
        }

        if(stripeError !== ''){
            dispatchDisabledButton(false)
            dispatchSubmitFrom(false)
        }

        const title = ['Berätta vad ni vill ha hjälp med!', 'Tycker ni matte är...'];
        const content = {
            roligt_0 : {
                title: 'Jag lär dig grunderna på nolltid!',
                subTitle: 'Med mig får du tillgång till tusentals pedagogiska övningar speciellt framtagna för att barn ska förstå matematik enklare. Allt är framtaget av erfarna pedagoger, lärare och forskare.',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',
                note1: '(Ordinarie pris 99kr/månad)'
            },            
            roligt_1 : {
                title: 'Wohoo, du har hamnat rätt!',
                subTitle: 'Hos mig hittar du tusentals roliga övningar som anpassats efter din årskurs - nu kör vi!',
                list: [' Kopplad till läroplanen',  ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },
            
            roligt_2 : {
                title: 'Övning ger färdighet!',
                subTitle: 'Tillsammans ska vi se till att du blir en sann mattemästare. Du kan öva på matten för din årskurs eller gå upp och läsa mer avancerade nivåer - du bestämmer och jag hjälper dig hela vägen!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },
            
            mest_0 : {
                title: 'Känn ingen press, vi löser det tillsammans.',
                subTitle: 'Välj i lugn och ro bland massor med övningar. Samtliga har tagits fram av pedagoger, lärare och forskare för att göra matten roligare och mer engagerande. Plugga med mig tio minuter om dagen så kommer det gå fint!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },

            mest_1 : {
                title: 'Välj bland tusentals roliga övningar!',
                subTitle: 'Alla mina övningar har tagits fram av erfarna pedagoger, lärare och forskare - allt för att matten ska bli så kul som möjligt! Testa dig fram bland alla tusentals övningar, i din takt - när du vill!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: ''
            },

            mest_2 : {
                title: 'Känn ingen press.',
                subTitle: 'Att förstå matte kan vara svårt, men jag finns här för att hjälpa dig hela vägen. Med övning och tålamod kommer du nå målet - garanterat! Öva i minst 10 minuter om dagen så blir du en mattemästare innan du vet ordet av!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            }

            
        }

        return(
            <section className="steps-section" id="quiz">
                <div className="custom-container">
                    <div className="for-back">
                        <div className="steps-inner">
                        <ul>
                                    <li className={step === 0 ? 'active step-0' : (step > 0 ? 'done' : '') }>
                                     
                                        <span></span>
                                    </li>
                                    <li className={step === 1 && step > 0 ? 'active step-1' : (step > 1 ? 'done' : '')}>
                                        <span></span>
                                    </li>
                                    <li className={step === 2 && step > 1 ? 'active step-2' : (step > 2 ? 'done' : '')}>
                                        <span></span>
                                    </li>
                                    <li className={step === 3 && step > 1 ? 'active step-3' : (step > 3 ? 'done' : '')}>
                                        <span></span>
                                    </li>
                                  <div className="for-active"></div>
                                </ul>
                                {
                                    title[step] && (
                                        <h3>{title[step]}</h3>
                                    )
                                }
                                <div className="new-midd-sec">
                                    {
                                        step === 0 && (
                                            <Fragment>
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(1, 0);
                                                        logEvent(
                                                            `Junior quiz Mitt barn vill lära sig räkna button`,
                                                            `Junior quiz Mitt barn vill lära sig räkna button was clicked`
                                                        )
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Junior Quiz Mitt Barn Vill Lära Sig Räkna Button',
                                                            'Junior Quiz Mitt Barn Vill Lära Sig Räkna Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                >
                                                    Mitt barn vill lära sig räkna
                                                </button>
                                                <button type="button" onClick={e => {
                                                    this.gotoStep(1, 1);
                                                    logEvent(
                                                        `Junior quiz Öva med roligare matte button`,
                                                        `Junior quiz Öva med roligare matte button was clicked`
                                                    )
                                                    pushToDataLayer(
                                                        'userClick',
                                                        'Junior Quiz Öva Med Roligare Matte Button',
                                                        'Junior Quiz Öva Med Roligare Matte Button Was Clicked'
                                                    )
                                                }
                                                }
                                                >
                                                    Öva med roligare matte
                                                </button>
                                                <button type="button" onClick={e => {
                                                    this.gotoStep(1, 2);
                                                    logEvent(
                                                        `Junior quiz Bli en mattemästare button`,
                                                        `Junior quiz Bli en mattemästare button was clicked`
                                                    )
                                                    pushToDataLayer(
                                                        'userClick',
                                                        'Junior Quiz Bli En Mattemästare',
                                                        'Junior Quiz Bli En Mattemästare Button Was Clicked'
                                                    )
                                                }
                                                }
                                                >
                                                    Bli en mattemästare
                                                </button>
                                            </Fragment>
                                        )
                                    }

                                    {
                                        step === 1 && (
                                            <Fragment>
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(2, contentNo, 'roligt');
                                                        logEvent(
                                                            `Junior quiz Roligt button`,
                                                            `Junior quiz Roligt button was clicked`
                                                        )
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Junior Quiz Roligt Button',
                                                            'Junior Quiz Roligt Button Was Clicked',
                                                        )
                                                    }
                                                }
                                                >
                                                    Roligt
                                                </button>
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(2, contentNo, 'mest');
                                                        logEvent(
                                                            `Junior quiz Mest jobbigt button`,
                                                            `Junior quiz Mest jobbigt button was clicked`
                                                        )
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Junior Quiz Mest Jobbigt Button',
                                                            'Junior Quiz Mest Jobbigt Button Was Clicked',
                                                        )
                                                    }
                                                }
                                                >
                                                    Mest jobbigt
                                                </button>

                                                <span className="backQuizBtn"  onClick={e => {
                                                        this.back(0);
                                                        logEvent(
                                                            `Junior quiz Tillbaka button`,
                                                            `Junior quiz Tillbaka button was clicked`
                                                        )
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Junior Quiz Tillbaka Button',
                                                            'Junior Quiz Tillbaka Button Was Clicked',
                                                        )
                                                    }
                                                }
                                                ><GrayArrow /> Tillbaka</span>
                                            </Fragment>
                                        )
                                    }

                                    {
                                        step === 2 && (
                                            <Fragment>
                                                <h3>{content[contentType+'_'+contentNo].title}</h3>
                                                <p>{content[contentType+'_'+contentNo].subTitle}</p>
                                                    <ul>
                                                    {
                                                        content[contentType+'_'+contentNo].list.map((n, key) => {
                                                            return (
                                                                <li key={key} >{n}</li>
                                                            )
                                                        })
                                                    }
                                                    </ul>
                                                
                                                {
                                                    content[contentType+'_'+contentNo].note && (
                                                        <p><b>{content[contentType+'_'+contentNo].note}</b></p>
                                                    )
                                                }
                                                {
                                                    content[contentType+'_'+contentNo].note1 && (
                                                        <p><i>{content[contentType+'_'+contentNo].note1}</i></p>
                                                    )
                                                }
                                                
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(3, contentNo, contentType);
                                                        logEvent(
                                                            `Junior quiz Registrera dig nu button`,
                                                            `Junior quiz Registrera dig nu button was clicked`
                                                        )
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Junior Quiz Registrera Dig Nu Button',
                                                            'Junior Quiz Registrera Dig Nu Button Was Clicked',
                                                        )
                                                    }
                                                }
                                                >Registrera dig nu</button><br/>
                                                <span className="backQuizBtn"  onClick={e => {
                                                        this.back(1);
                                                        logEvent(
                                                            `Junior quiz Tillbaka button`,
                                                            `Junior quiz Tillbaka button was clicked`
                                                        )
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Junior Quiz Tillbaka Button',
                                                            'Junior Quiz Tillbaka Button Was Clicked',
                                                        )
                                                    }
                                                }
                                                ><GrayArrow /> Tillbaka</span>
                                            </Fragment>
                                        )
                                    }

                                    {
                                        step === 3 && (
                                            <StripeProvider apiKey={process.env.STRIPE_PK}>
                                                <form>
                                                    <h3>Registrera dig</h3>
                                                    <div className='accountFormEmail'>
                                                        <h4>E-post</h4>
                                                        <input className={juniorEmailError!== '' ? 'errorField' : ''} placeholder="Ange E-postadress" type='email' id='email' onBlur={() => this.domainCorrection()} value={email} onChange={e => this.handleInput(e)}/>
                                                        <label className="text-error">{juniorEmailError}</label>
                                                        <label className="text-error">{emailDomainError}</label>
                                                    </div>
                                                    <Elements>
                                                        <PaymentForm />
                                                    </Elements>
                                                    <label className="text-error">{stripeError}</label>
                                                    <div className='accountFormRegisterButtonMobile'>
                                                        <input type='checkbox' id='terms_and_conditions' onChange={e => this.handleClick(e)} />
                                                        <label htmlFor='terms_and_conditions'>Jag godkänner Alberts <a href="/terms-and-conditions" target="_blank" className='color-text'> Allmänna Villkor </a></label>
                                                    </div>
                                                    <label className="text-error">{juniorCheckboxError}</label>

                                                    <Fab
                                                        variant="extended"
                                                        // size="small"
                                                        color="primary"
                                                        aria-label="Add"
                                                        className="registerButton payment-btn"
                                                        disabled={buttonDisabled}
                                                        onClick={e => {
                                                            this.validate();
                                                            logEvent(
                                                                `Junior quiz Påbörja din gratisperiod button`,
                                                                `Junior quiz Påbörja din gratisperiod button was clicked`
                                                            )
                                                            pushToDataLayer(
                                                                'userClick',
                                                                'Junior Quiz Påbörja Din Gratisperiod Button',
                                                                'Junior Quiz Påbörja Din Gratisperiod Button Was Clicked',
                                                            )
                                                        }}
                                                        >
                                                        Påbörja din gratisperiod
                                                    </Fab>
                                                    
                                                    {
                                                        submitForm && (
                                                            <div className="loader-cenetr"> <Spinner size={48}/></div>
                                                        )
                                                    }

                                                    <h6><Lock /> &nbsp; Säker kortbetalning via en krypterad anslutning.</h6>
                                                    {/* <h6>Bra att veta: Efter 30 dagar övergår gratiskontot till ett premiumkonto för 99kr/mån. Du kan närsomhelst, utan uppsägningstid, avsluta ditt abonnemang genom att logga in på Mina Sidor.</h6> */}
                                                    <h6>Bra att veta: Prenumerationen är helt gratis i 30 dagar, därefter 99kr/mån. Du kan närsomhelst, utan uppsägningstid, avsluta ditt abonnemang genom att logga in på Mina Sidor.</h6>
                                                </form>
                                            </StripeProvider>
                                        )
                                    }
                                </div>
                        </div>
                    </div>	
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.juniorToken,
        submitForm: state.juniorFormSubmit,
        stripeError: state.juniorStripeError,
        buttonDisabled: state.buttonDisabled,
        juniorEmailError: state.juniorEmailError,
        juniorCheckboxError: state.juniorCheckboxError
    }
}
  
const mapDispatchToProps = dispatch => {
    return { 
        dispatchSetToken: (token) => dispatch({ type: `JUNIOR_TOKEN`, value: token }),
        dispatchSubmitFrom: (status) => dispatch({ type: `JUNIOR_FORM_SUBMIT`, value: status }),
        dispatchStripeError: (error) => dispatch({ type: `JUNIOR_STRIPE_ERROR`, value: error }),
        dispatchGenerateToken: (status) => dispatch({ type: `JUNIOR_GENERATE_TOKEN`, value: status }),
        dispatchDisabledButton: (status) => dispatch({ type: `DISABLED_BUTTON`, value: status }),
        dispatchEmailError: (status) => dispatch({ type: `JUNIOR_EMAIL_ERROR`, value: status }),
        dispatchCheckboxError: (status) => dispatch({ type: `JUNIOR_CHECKBOX_ERROR`, value: status }),
    }
}
  
const QuizClass = connect(mapStateToProps, mapDispatchToProps)(Quiz)

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    iPhone: file(relativePath: {regex: "/iphone-mob/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <QuizClass query={data} {...props}/>
        )}
    />
)